import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsAll = ({ color, opacity = '1', fillOpacity = '1', size = 20, props }: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M2.50033 5.83317V2.49984L5.83366 4.1665L2.50033 5.83317ZM15.0003 5.83317V2.49984L18.3337 4.1665L15.0003 5.83317ZM9.16699 4.99984V1.6665L12.5003 3.33317L9.16699 4.99984ZM7.50033 18.229C6.7781 18.1596 6.06977 18.0554 5.37533 17.9165C4.68088 17.7776 4.05935 17.6075 3.51074 17.4061C2.96213 17.2047 2.51769 16.9721 2.17741 16.7082C1.83713 16.4443 1.66699 16.1526 1.66699 15.8332V8.33317C1.66699 7.98595 1.88574 7.66303 2.32324 7.36442C2.76074 7.06581 3.35449 6.80192 4.10449 6.57275C4.85449 6.34359 5.73644 6.16303 6.75033 6.03109C7.76421 5.89914 8.84755 5.83317 10.0003 5.83317C11.1531 5.83317 12.2364 5.89914 13.2503 6.03109C14.2642 6.16303 15.1462 6.34359 15.8962 6.57275C16.6462 6.80192 17.2399 7.06581 17.6774 7.36442C18.1149 7.66303 18.3337 7.98595 18.3337 8.33317V15.8332C18.3337 16.1526 18.1635 16.4443 17.8232 16.7082C17.483 16.9721 17.0385 17.2047 16.4899 17.4061C15.9413 17.6075 15.3198 17.7776 14.6253 17.9165C13.9309 18.0554 13.2225 18.1596 12.5003 18.229V14.1665H7.50033V18.229ZM10.0003 9.1665C11.3475 9.1665 12.5107 9.08664 13.4899 8.92692C14.4691 8.7672 15.2503 8.58317 15.8337 8.37484C15.8337 8.30539 15.3059 8.1422 14.2503 7.88525C13.1948 7.62831 11.7781 7.49984 10.0003 7.49984C8.22255 7.49984 6.80588 7.62831 5.75033 7.88525C4.69477 8.1422 4.16699 8.30539 4.16699 8.37484C4.75033 8.58317 5.53158 8.7672 6.51074 8.92692C7.48991 9.08664 8.6531 9.1665 10.0003 9.1665Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
